import { createAction, props } from '@ngrx/store';

import { NotificationCommandProps } from '@features/notification/domain/models/notification.models';

/**
 * Creación de las acciones de Redux para el layout
 */
export const NotificationActionTypes = {
    OPEN_NOTIFICATION: '[Layout] OPEN_NOTIFICATION',
    OPEN_NOTIFICATION_SUCCESS: '[Layout] OPEN_NOTIFICATION_SUCCESS',

    CLOSE_NOTIFICATION: '[Layout] CLOSE_NOTIFICATION',

    CREATE_NOTIFICATION_COMPONENT_SUCCESS: '[notification] CREATE_NOTIFICATION_COMPONENT_SUCCESS',
    CREATE_NOTIFICATION_COMPONENT_ERROR: '[notification] CREATE_NOTIFICATION_COMPONENT_ERROR',
};

export const CreateNotificationComponentError = createAction(NotificationActionTypes.CREATE_NOTIFICATION_COMPONENT_SUCCESS);
export const CreateNotificationComponentSuccess = createAction(NotificationActionTypes.CREATE_NOTIFICATION_COMPONENT_ERROR);

export const OpenNotification = createAction(
    NotificationActionTypes.OPEN_NOTIFICATION,
    props<NotificationCommandProps>()
);
export const OpenNotificationSuccess = createAction(NotificationActionTypes.OPEN_NOTIFICATION_SUCCESS);

export const CloseNotification = createAction(NotificationActionTypes.CLOSE_NOTIFICATION);
